"use strict";
'use client';
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var apps_shared_1 = require("@l2p/apps-shared");
var swr_hooks_1 = require("@l2p/swr-hooks");
var ui_components_1 = require("@l2p/ui-components");
var next_intl_1 = require("next-intl");
var react_1 = __importStar(require("react"));
var react_html_parser_1 = __importDefault(require("react-html-parser"));
var SlideElements_1 = require("../../SlideElements");
var styles_module_scss_1 = __importDefault(require("./styles.module.scss"));
var useFilteredPromotions_1 = require("./useFilteredPromotions");
var DayOfWeekTimer = function (_a) {
    var activeDayOfWeek = _a.activeDayOfWeek, promo = _a.promo;
    var t = (0, next_intl_1.useTranslations)();
    var breakpoints = (0, apps_shared_1.useBreakpoint)();
    var promoActive = (0, react_1.useMemo)(function () {
        return (0, apps_shared_1.checkPromoDay)(activeDayOfWeek);
    }, [activeDayOfWeek]);
    var isAuth = (0, swr_hooks_1.useIsAuthorized)();
    var openDeposit = (0, apps_shared_1.useOpenDeposit)();
    var signUpNavigate = (0, apps_shared_1.useOpenSignUp)();
    return (react_1.default.createElement(react_1.default.Fragment, null, (promoActive === null || promoActive === void 0 ? void 0 : promoActive.active) ? (react_1.default.createElement("div", { className: styles_module_scss_1.default.buttonWrapper },
        react_1.default.createElement(ui_components_1.FixedButton, { color: "gradient", text: "upper", onClick: isAuth ? openDeposit : signUpNavigate }, t('translation.deposit')))) : (react_1.default.createElement("div", { className: styles_module_scss_1.default.timerWrapper },
        react_1.default.createElement(ui_components_1.Timer, { endDate: promoActive === null || promoActive === void 0 ? void 0 : promoActive.startAt, inGame: breakpoints.mobile || breakpoints.tablet, title: t('translation.startAfter'), hideFinishLabel: false })))));
};
var Promotions = function () {
    var _a = (0, useFilteredPromotions_1.useFilteredPromotions)(), promotions = _a.promotions, isLoading = _a.isLoading;
    if (isLoading)
        return null;
    return (react_1.default.createElement("div", { className: "".concat(styles_module_scss_1.default.container) }, promotions.length && (react_1.default.createElement(SlideElements_1.SliderInBanner, null, promotions.map(function (promo) {
        var _a;
        return (react_1.default.createElement(react_1.default.Fragment, { key: promo.id },
            react_1.default.createElement("h2", { className: styles_module_scss_1.default.slideTitle }, promo.title),
            react_1.default.createElement("div", { className: styles_module_scss_1.default.slideDescription }, (0, react_html_parser_1.default)((_a = promo === null || promo === void 0 ? void 0 : promo.descriptions) === null || _a === void 0 ? void 0 : _a.short)),
            react_1.default.createElement(DayOfWeekTimer, { activeDayOfWeek: promo === null || promo === void 0 ? void 0 : promo.activeDayOfWeek, promo: promo })));
    })))));
};
exports.default = Promotions;
